<template>
    <g fill="none" fill-rule="evenodd">
        <path fill="#8E44AD" d="M32.852 16.695l-4.708-.045.085-9.065 4.694.044c1.665.016 2.738 1.014 2.724 2.502-.012 1.245-.896 1.832-1.506 1.894v.054c.838.075 1.738.733 1.725 2.1-.014 1.502-1.038 2.534-3.014 2.516M31.536 0c-4.482-.042-8.407 2.397-10.474 6.036 1.087 1.664 1.711 3.656 1.691 5.793-.02 2.136-.681 4.116-1.799 5.76 2 3.677 5.878 6.19 10.359 6.232 6.578.06 11.96-5.221 12.022-11.8.061-6.578-5.222-11.96-11.8-12.021m1.945 10.367c.005-.568-.438-.938-1.006-.943l-2.03-.02-.018 1.95 1.948.017c.663.007 1.1-.395 1.106-1.004m-.944 2.535l-2.124-.02-.019 1.989 2.084.02c.717.006 1.113-.383 1.119-1.005.006-.595-.424-.978-1.06-.984"/>
        <path fill="#FFC43C" d="M13.929 16.779l-.636-1.65H9.477l-.636 1.65H6.446l3.789-9.066h2.287l3.788 9.066h-2.381zM11.745.173C5.258.173 0 5.432 0 11.918c0 6.486 5.258 11.745 11.745 11.745 6.486 0 11.744-5.259 11.744-11.745C23.49 5.432 18.231.173 11.745.173zm-1.51 13.034h2.314l-1.164-2.977-1.15 2.977z"/>
    </g>
</template>

<script>
export default {
    name: 'abColorIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 44 24');
    }
};
</script>
